export enum  PrivacyConsent{

    ACCEPTED = 'ACCEPTED',

    NOT_ACCEPTED = 'NOT_ACCEPTED'
}